/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Filter_MemoryInputs */



/**
* | output |
* | --- |
* | "Conversation info available ({count})" |
*
* @param {Team_Filter_MemoryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_filter_memory = /** @type {((inputs: Team_Filter_MemoryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Filter_MemoryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Gespreksinfo beschikbaar (${i?.count})`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Infos d'entretien disponibles (${i?.count})`)
	return /** @type {LocalizedString} */ (`Conversation info available (${i?.count})`)
});